var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7594 4.73209L12.268 1.24146C12.1519 1.12536 12.0141 1.03326 11.8624 0.970422C11.7107 0.907586 11.5482 0.875244 11.384 0.875244C11.2198 0.875244 11.0572 0.907586 10.9056 0.970422C10.7539 1.03326 10.6161 1.12536 10.5 1.24146L0.866412 10.8751C0.749834 10.9907 0.657407 11.1284 0.594506 11.2801C0.531604 11.4318 0.499482 11.5944 0.500006 11.7586V15.2501C0.500006 15.5816 0.631702 15.8995 0.866123 16.1339C1.10054 16.3684 1.41849 16.5001 1.75001 16.5001H14.875C15.0408 16.5001 15.1997 16.4342 15.3169 16.317C15.4342 16.1998 15.5 16.0408 15.5 15.8751C15.5 15.7093 15.4342 15.5503 15.3169 15.4331C15.1997 15.3159 15.0408 15.2501 14.875 15.2501H7.00938L15.7594 6.50006C15.8755 6.38398 15.9676 6.24617 16.0304 6.09449C16.0933 5.94282 16.1256 5.78025 16.1256 5.61607C16.1256 5.45189 16.0933 5.28933 16.0304 5.13765C15.9676 4.98597 15.8755 4.84816 15.7594 4.73209ZM5.24141 15.2501H1.75001V11.7586L8.62501 4.88365L12.1164 8.37506L5.24141 15.2501ZM13 7.49146L9.50938 4.00006L11.3844 2.12506L14.875 5.61646L13 7.49146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.877fdf1419e53ad47aa2c5b2f04d6b53.svg";
export { ForwardRef as ReactComponent };